import { SiteInfo } from "@/globals";
import Link from "next/link";

type NavItem = { title: string; href: string };

const navItems: NavItem[] = [
  { title: '대시보드', href: '/' },
  { title: '카테고리', href: '/categories' },
  { title: '주문 조회', href: '/orders' },
  { title: '상품 관리', href: '/products' },
  { title: '상품 검색', href: '/search' },
];

export default function AdminLayout({ children }: any) {
    return (
      <>
        <header className="fixed w-full h-[60px] top-0 bg-black z-50">
          <ul className="flex flex-wrap h-[100%] items-center text-sm text-white">
            { navItems.map((item, index) => {
              return (
              <li key={item.title} className={`${index === 0 ? 'ml-8' : ''} mr-6 block`}>
                <a href={`/admin${item.href}`}>{item.title}</a>
              </li>
              );
            }) }
            <li className="ml-auto mr-6 block"><a href={ `https://www.hotalideal.com` } target="_blank" className="flex">{ SiteInfo.siteName }</a></li>
            <li className="mr-4 block"><a href="https://portals.aliexpress.com/affiportals/web/home.htm" target="_blank" className="flex"><img src="https://ae01.alicdn.com/images/eng/wholesale/icon/aliexpress.ico" width={20} height={20} className="mr-2" alt="Portals"/>Portals</a></li>
            <li className="mr-8 block"><a href="https://openservice.aliexpress.com/app/index.htm#/app/overview?appkey=508970" target="_blank" className="flex">App Console</a></li>
          </ul>
        </header>
        
        <main className="justify-center max-w-[1280px] min-h-[calc(100vh-60px-96px)]
        pt-[84px] p-[16px] sm:pt-[84px] sm:p-[24px] mx-auto mt-2">
          { children }
        </main>
      </>
    );
  }